import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../../PricingHub/SearchComponent';

class UomSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.name',
      name: 'name',
    },
    {
      label: 'label.symbol',
      name: 'symbol',
    },
  ];

  btnSpan = 'col-md-6';
}

UomSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

UomSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(UomSearchForm);
